import { Header } from 'shared/components/Header';
import { MainContentContainer } from '../MainContent';
import { Footer } from 'shared/components/Footer';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { PriceContentContainer } from '../PriceContent';
import { Responsive } from '@cian/ui-kit';

export const PagesContainer: React.FC = () => {
  const {
    custom: { pageType },
  } = useApplicationContext();

  const content = pageType === 'price' ? <PriceContentContainer /> : <MainContentContainer />;

  return (
    <div>
      <Responsive desktop tablet>
        <Header />
      </Responsive>
      {content}
      <Footer />
    </div>
  );
};
